import React from 'react';
import { Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import useRequestHouses from '../../../../../../queries/useRequestHouses';
import { housesSelector, streetsSelector } from '../../../../store/selectors';
import { setFilterState } from '../../../../store/actions';
import { filterNames } from '../../../../constants/common';

const SelectHouses = ({ className }) => {
  const dispatch = useDispatch();
  const selectedStreets = useSelector(streetsSelector);
  const selectedHouses = useSelector(housesSelector);

  const { data: houses, isFetching } = useRequestHouses(selectedStreets[0], {
    staleTime: Infinity,
    enabled: Boolean(selectedStreets.length),
  });

  const handleChange = (value) => {
    dispatch(setFilterState({ filterName: filterNames.houses, value }));
  };

  return (
    <Select
      onChange={handleChange}
      className={className}
      loading={isFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear={true}
      placeholder="Дом"
      value={houses ? selectedHouses : []}
      optionFilterProp="searchtext"
    >
      {houses?.map((house) => (
        <Select.Option key={house.id} value={house.id} searchtext={house.name}>
          {house.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectHouses;
